<template>
  <div class="row mb-3 align-items-center">
    <div class="col-6 col-sm-8">
      <slot></slot>
    </div>
    <div class="col-6 col-sm-4 text-end">
      <button @click="showFilters = !showFilters" :class="btnClass">
        <span v-if="!showFilters">{{ i18n('Show filters') }}</span>
        <span v-if="showFilters">{{ i18n('Hide filters') }}</span>
      </button>
      <slot name="buttons"></slot>
    </div>
    <Transition>
      <div class="col-12 col-sm-6 col-lg-6" v-if="!showFilters">
        <Field type="text" v-model="filters.q" :label="i18n('Search')" />
      </div>
    </Transition>
  </div>
  <Transition>
    <div class="filters" v-if="showFilters">
      <div class="p-2 border bg-white">
        <div class="row g-2">
          <div class="col-12 col-sm-6 col-lg-8">
            <Field type="text" v-model="filters.q" :label="i18n('Search')" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field type="dictionary" v-model="filters.userType" :label="i18n('User Type')" rest="types/users"
              format="object" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field type="text" v-model="filters.name" :label="i18n('Name')" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field type="email" v-model="filters.email" :label="i18n('Email')" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field type="text" v-model="filters.document" :label="i18n('Document')" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field type="text" v-model="filters.origin_identifier" :label="i18n('Username')" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field v-model="filters.responsibleExternalUser" :label="i18n('Responsible User')"
              :rest="`companies/of-group/users`" format="object" type="dictionary" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field v-model="filters.is_client" :label="i18n('Client')" type="dictionary" format="boolean"
              :hash="{ false: i18n('No'), true: i18n('Yes') }" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4" v-if="can('COMPANY_ACCESS') || can('COMPANY_LIST_ACCESS')">
            <Field type="dictionary" v-model="filters.company" :label="i18n('Company')" rest="companies?order_by_name=1"
              format="object" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4" v-if="(can('COMPANY_ACCESS') || can('COMPANY_LIST_ACCESS')) && filters?.company?.id">
            <Field v-model="filters.office" :label="i18n('Office')" type="dictionary"
              :rest="`companies/${filters?.company?.id}/offices?order_by_name=1`" format="object" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4" v-if="(can('COMPANY_ACCESS') || can('COMPANY_LIST_ACCESS')) && filters?.company?.id">
            <Field v-model="filters.department" :label="i18n('Department')" type="dictionary"
              :rest="`companies/${filters?.company?.id}/departments?order_by_name=1`" format="object" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4" v-if="can('TEAM_ACCESS')">
            <Field v-model="filters.team" :label="i18n('Team')" type="dictionary" rest="teams?order_by_name=1" format="object" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4">
            <Field v-model="filters.is_deleted" :label="i18n('Status')" type="dictionary" :placeholder="null"
              :hash="{ 'all': i18n('All'), 0: i18n('Active'), 1: i18n('Inactive') }" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4" v-if="can('APPLICATION_ACCESS') || can('APPLICATION_LIST_ACCESS')">
            <Field v-model="filters.application" :label="i18n('Applications')" type="dictionary" rest="applications?not_only_show_for_employee=1&order_by_name=1"
              format="object" />
          </div>
          <div class="col-12 col-sm-6 col-lg-4" v-if="filters?.application?.id && (can('APPLICATION_ACCESS') || can('APPLICATION_LIST_ACCESS'))">
            <Field v-model="filters.profile" :label="i18n('Profiles')" type="dictionary"
              :rest="`applications/${filters?.application?.id}/profiles`" format="object" />
          </div>
        </div>
      </div>
    </div>
  </Transition>
  <Transition>
    <FilterBadgeList v-if="!showFilters" :filters="filters" :badgeFunction="badgeFunctionDelegate" />
  </Transition>
</template>

<script>
import Field from "@/components/common/form/Field.vue";
import FilterBadgeList from "@/components/common/list/FilterBadgeList.vue";

export default {
  components: {
    Field,
    FilterBadgeList,
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn btn-sm btn-outline-dark',
    },
    filters: {
      type: Object,
      default() {
        return {};
      },
    },
    expiresSoon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showFilters: false,
    };
  },
  created() {
    if (this.$route.hash.includes('ids')) {
      this.filters.ids = this.$route.hash.split('ids=')[1].split(',');
    }
  },
  methods: {
    badgeFunctionDelegate(badges, key, value) {
      if (key === 'q') {
        // Do not show badge for q, since it is always visible
        return true;
      }

      return false;
    },
  }
};
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
  transition: all 200ms ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
  overflow: hidden;
  max-height: 0;
}

.v-enter-to,
.v-leave-from {
  opacity: 1;
  overflow: hidden;
  max-height: 900px;
}
</style>